module.exports = __webpack_public_path__ + "img/border_bottom_2.c8670f26.png";